/* eslint-disable max-statements */
import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useSelector } from 'react-redux';
import { Tooltip } from 'primereact/tooltip';
import { DataTable } from 'primereact/datatable';
import { CaSearchFilter } from '../searchCorrectiveActionTemplate/CaSearchFilter';
import DisputedIcon from '../../../assets/DisputedIcon.svg';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import {
    useGetCaLanguageQuery,
    useUpdateConfigureStatusMutation,
    useGetCaTemplateNoticeQuery,
    useCreateConfigureMutation,
    useUpdateConfigureMutation,
    useGetCaSeverityLevelQuery,
    useGetCaTokensQuery,
} from './CaConfigure.slice';
import './CaConfigure.scss';
import AskCreateTemplateIcon from '../../../assets/DisputeNotification.png';
import CreatedTemplateIcon from '../../../assets/TemplateCreatedSuccessIcon.png';
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import { Tabindex } from '../../../utils/typeConstants';
import { Country, Category, Role, Template, DeleteConfig } from '../type';
import VertexAI from '../../../components/vertexAI/VertexAI';
import VoiceToText from '../../../components/voiceToTextArea/voiceToText';

interface CaConfigurePropTypes {
    selectedCountry: Country;
    selectedCategory: Category;
    selectedRole: Role;
    selectedLanguage?: number;
    selectedCaTemplate: Template;
    setSelectedLanguage: (e: number | undefined) => void;
    setIsUpdateApprovalQueues: (e: boolean) => void;
    setActiveIndex: (e: number) => void;
}

export const CaConfigure = (props: CaConfigurePropTypes) => {
    const [askcreateTempDialogVisible, setAskcreateTempDialogVisible] = useState<boolean>(false);
    const [createdSuccessTempdialogVisible, setCreatedSuccessTempdialogVisible] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [successHeader, setSuccessHeader] = useState<string>('');
    const [showDeleteOption, setShowDeleteOption] = useState(false);
    const handleDragStat = (e: any, item: any) => {
        e.dataTransfer.setData('item', JSON.stringify(item));
    };

    const handleDrop = (e: any, index: number) => {
        e.preventDefault();
        const droppedItem = JSON.parse(e.dataTransfer.getData('item'));
        const newItem = [...caTokens];
        newItem.splice(index, 0, droppedItem);
        setValue((prevText) => prevText + ' ' + droppedItem.ca_template_token);
    };

    const handleDragOver = (e: any) => {
        e.preventDefault();
    };

    const menu = useRef<Menu>(null);
    const items = [];
    items.push(
        {
            label: 'Edit',
            icon: 'pi pi-pencil',
            visible: true,
            command: () => {
                setEdit(true);
                window.scrollTo(0, 0);
                setSelectedSeverityLevel(selectedRow.severity_level_id);
                props.setSelectedLanguage(selectedRow.emp_language_id);
                setValue(selectedRow.template_notice_text);
            },
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            visible: showDeleteOption,
            command: () => {
                deleteTemplateNotice();
            },
        }
    );
    const popupMenuClickHandler = (e: any, rowData: any) => {
        e.preventDefault();
        if (rowData.templateUsedCount > 0) setShowDeleteOption(false);
        else setShowDeleteOption(true);
        menu.current?.toggle(e);
        setSelectedRow(rowData);
    };

    const { data: caLanguageData } = useGetCaLanguageQuery();
    const { data: caSeverityLevelData } = useGetCaSeverityLevelQuery({
        countryId: props.selectedCountry.country_id,
        isHCUser: true, // Passing true to retrieve all severity levels without user-specific limitations
    });
    const { data: caTokensData } = useGetCaTokensQuery();

    const { data: caTemplateNoticeData } = useGetCaTemplateNoticeQuery(
        {
            caTemplateId: props.selectedCaTemplate.ca_template_id,
        },
        { skip: !props.selectedCaTemplate.ca_template_id }
    );

    const [caLanguage, setCaLanguage] = useState<any>([]);
    const [caSeverityLevel, setCaSeverityLevel] = useState<any>([]);
    const [caTokens, setCaTokens] = useState<any>([]);
    const [caTemplateNotice, setCaTemplateNotice] = useState<any>([]);

    const [selectedSeverityLevel, setSelectedSeverityLevel] = useState<number>();

    const [selectedRow, setSelectedRow] = useState<any>();

    const [value, setValue] = useState('');

    const [isEdit, setEdit] = useState<boolean>(false);

    const [CreateConfigure] = useCreateConfigureMutation();
    const [UpdateConfigure] = useUpdateConfigureMutation();
    const [DeleteTemplateNotice] = useUpdateConfigureStatusMutation();

    const loggedEmpNum = useSelector(selectCurrentEmpid);

    useEffect(() => {
        setCaTemplateNotice(caTemplateNoticeData?.data?.length > 0 ? caTemplateNoticeData.data : []);
    }, [caTemplateNoticeData]);

    useEffect(() => {
        setCaTokens(caTokensData?.data?.length > 0 ? caTokensData.data : []);
    }, [caTokensData]);

    useEffect(() => {
        setCaLanguage(caLanguageData?.data?.length > 0 ? caLanguageData.data : []);
    }, [caLanguageData]);

    useEffect(() => {
        setCaSeverityLevel(caSeverityLevelData?.data?.length > 0 ? caSeverityLevelData.data : []);
    }, [caSeverityLevelData]);

    const idDuplicate = () => {
        // return false
        if (isEdit) {
            return false;
        } else {
            return caTemplateNotice.some(
                (item: any) =>
                    item.severity_level_id === selectedSeverityLevel &&
                    item.emp_language_id === props.selectedLanguage
            );
        }
    };

    const handleReset = () => {
        setSelectedSeverityLevel(undefined);
        props.setSelectedLanguage(undefined);
        setValue('');
    };

    const handleCancel = () => {
        setEdit(false);
        handleReset();
    };

    const deleteTemplateNotice = () => {
        const data = {
            caTemplateNoticeId: selectedRow.ca_template_notice_id,
            caModifyby: loggedEmpNum,
        };
        deleteTemplate(data);
    };

    const deleteTemplate = (data: DeleteConfig) => {
        DeleteTemplateNotice(data)
            .unwrap()
            .then((response: any) => {
                console.log('response', response);
                toast.success('Deleted Successfully');
            })
            .then((error: any) => {
                if (error) {
                    console.log(error);
                    toast.error('Error');
                }
            });
    };

    const createdSuccessTempDialogFuncMap = {
        createdSuccessTempDialogBox: setCreatedSuccessTempdialogVisible,
    };
    const askCreateTempDialogFuncMap = {
        askCreateTempDialogBox: setAskcreateTempDialogVisible,
    };

    const onAskCreateTempDialogBoxHide = () => {
        askCreateTempDialogFuncMap.askCreateTempDialogBox(false);
    };

    const onCreatedSuccessTempDialogBoxHide = () => {
        createdSuccessTempDialogFuncMap.createdSuccessTempDialogBox(false);
    };

    const configureHandler = () => {
        if (!value || value === '') {
            toast.error('Please add Notice');
            return;
        }
        if (!props.selectedLanguage) {
            toast.error('Please select language');
            return;
        }

        if (!selectedSeverityLevel) {
            toast.error('Please select Severity Level');
            return;
        }
        setSuccessHeader('Add item');
        setWarningMessage('Are you sure you want to add this configurated item?');
        setAskcreateTempDialogVisible(true);
    };

    const updateConfigureHandler = () => {
        if (!value || value === '') {
            toast.error('Please add Notice');
            return;
        }
        setSuccessHeader('Update item');
        setWarningMessage('Are you sure you want to update this configurated item?');
        setAskcreateTempDialogVisible(true);
    };

    const updaeConfigure = () => {
        const configure = {
            'p_template_notice_text': value,
            'modify_by': loggedEmpNum,
            'p_ca_template_notice_id': selectedRow.ca_template_notice_id,
        };
        UpdateConfigure(configure)
            .unwrap()
            .then((error: any) => {
                if (error) console.log(error);
                setSuccessHeader('Updated!');
                setSuccessMessage('Configurated item is updated');
                setAskcreateTempDialogVisible(false);
                setCreatedSuccessTempdialogVisible(true);
                handleCancel();
            });
    };

    const createConfigurated = () => {
        const configure = {
            'p_template_notice_text': value,
            'modify_by': loggedEmpNum,
            'severity_level_id': selectedSeverityLevel,
            'emp_language_id': props.selectedLanguage,
            'p_ca_template_id': props.selectedCaTemplate.ca_template_id,
        };
        if (isValidateConfigure(configure)) {
            CreateConfigure(configure)
                .unwrap()
                .then((error: any) => {
                    if (error) console.log(error);
                    handleReset();
                    setSuccessHeader('Added!');
                    setSuccessMessage('Configurated item is added');
                    setAskcreateTempDialogVisible(false);
                    setCreatedSuccessTempdialogVisible(true);
                });
        } else {
            toast.error('Invalid configure data');
        }
    };

    const isValidateConfigure = (data: any) => {
        if (
            typeof data.p_template_notice_text !== 'string' ||
            typeof data.modify_by !== 'string' ||
            typeof data.severity_level_id !== 'number' ||
            typeof data.emp_language_id !== 'number' ||
            typeof data.p_ca_template_id !== 'number'
        ) {
            return false;
        }
        return true;
    };

    const handleClickCancel = () => {
        onAskCreateTempDialogBoxHide();
    };

    const handleClickReturn = () => {
        onCreatedSuccessTempDialogBoxHide();
    };

    const handleClickYes = async () => {
        if (!isEdit) {
            createConfigurated();
        } else {
            updaeConfigure();
        }
    };

    const actionTemplate = (rowData: any) => {
        if (rowData !== null)
            return (
                <Button
                    type="button"
                    icon="pi pi-ellipsis-v"
                    className="flex-start"
                    onClick={(e: any) => {
                        popupMenuClickHandler(e, rowData);
                    }}
                />
            );
        return <div />;
    };

    const createFooterTemplate = (
        <div className="d-flex justify-content-center gap-2">
            <Button
                className="btn-secondary"
                onClick={handleClickCancel}
                label="Cancel"
            />
            <Button
                className="btn-primary"
                onClick={handleClickYes}
                label="Yes"
            />
        </div>
    );

    const CreatedSuccessfooterTemplate = (
        <div className="row flex justify-content-center ">
            <div className="col-md-6">
                <Button
                    className="btn-secondary w-100"
                    onClick={handleClickReturn}
                    label={'Continue'}
                />
            </div>
        </div>
    );

    const renderDescription = (text: string) => {
        return (
            <>
                <Tooltip target=".description-ca" position="top" />
                <div className="description-ca" data-pr-tooltip={text}>
                    <div className="text-ellipsis">{text}</div>
                </div>
            </>
        );
    };

    const updateFromAI = (value: string) => {
        setValue(value);
    };

    return (
        <>
            <div className="row">
                <div className="col-md-9">
                    <h5>Configuring {props.selectedCaTemplate.ca_template_name}</h5>
                </div>
                <div className="col-md-3">
                    <Button
                        type="button"
                        onClick={() => {
                            props.setIsUpdateApprovalQueues(true);
                            props.setActiveIndex(Tabindex.Create);
                        }}
                        label="Configure Approval Queue"
                        className="btn-primary"
                    />
                </div>
            </div>
            <h6 className="m-top-30">General Data</h6>
            <CaSearchFilter
                selectedCountry={props.selectedCountry}
                selectedCategory={props.selectedCategory}
                selectedRole={props.selectedRole}
                filterDisable
            />
            <h6 className="m-top-15">Information</h6>
            <div className="row">
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="countrydd">Severity Level*</label>
                        <Dropdown
                            id="severity_level_id"
                            placeholder="Severity Level"
                            className="custom-dropdown"
                            options={caSeverityLevel}
                            disabled={isEdit}
                            optionValue={'severity_level_id'}
                            optionLabel={'severity_level_name'}
                            aria-label="severity-level"
                            value={selectedSeverityLevel}
                            onChange={(e: any) => {
                                setSelectedSeverityLevel(e.value);
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="content">
                        <label htmlFor="countrydd">Language*</label>
                        <Dropdown
                            id="emp_language_id"
                            placeholder="Select Language"
                            className="custom-dropdown"
                            options={caLanguage}
                            disabled={isEdit}
                            optionValue={'emp_language_id'}
                            aria-label="language"
                            optionLabel={'emp_language_name'}
                            value={props.selectedLanguage}
                            onChange={(e: any) => {
                                props.setSelectedLanguage(e.value);
                            }}
                        />
                    </div>
                </div>
                {idDuplicate() && (
                    <div className="col-md-4">
                        <div className="warning-div">
                            {/* <DisputedIcon /> */}
                            <img src={DisputedIcon} alt="Delegate" className="pe-2" />
                            This template already exists. Please review and edit the Template Configuration
                        </div>
                    </div>
                )}
            </div>
            <div className="flex justify-content-center m-top-15">
                <h6>Notice*</h6>
                <div className="textarea-wrapper">
                    <div className="textarea-body">
                        <div className="textarea-resizable-container">
                            <InputTextarea
                                aria-label="notice"
                                onDrop={(e) => handleDrop(e, 0)}
                                onDragOver={handleDragOver}
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                rows={5}
                                className="w-full"
                            />
                            <div className="textarea-icons">
                                <VertexAI
                                    aiInputText={value}
                                    setTextAreaValue={updateFromAI}
                                    aiMaxLength={3900}
                                />
                                <VoiceToText transcript={value} onTranscriptChange={setValue} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="link-container">Empower.ttec.com</div>
            </div>
            <div className="flex justify-content-center m-top-15">
                <div>Template Tokens*</div>
                <div className="row width-80 m-top-15">
                    {caTokens.length > 0 &&
                        caTokens.map((tokens: any) => {
                            return (
                                <div
                                    draggable
                                    onDragStart={(e) => handleDragStat(e, tokens)}
                                    onDragOver={handleDragOver}
                                    key={tokens.ca_template_token_id}
                                    className="col-md-3 m-top-5"
                                >
                                    <p className="token-container">{tokens.ca_template_token_name}</p>
                                </div>
                            );
                        })}
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-3">
                {isEdit && (
                    <>
                        <Button
                            label="Cancel"
                            className="btn-secondary"
                            onClick={handleCancel}
                        />
                        <Button
                            type="button"
                            onClick={updateConfigureHandler}
                            label="Update"
                            className="btn-primary"
                        />
                    </>
                )}
                {!isEdit && (
                    <Button
                        type="button"
                        disabled={idDuplicate()}
                        onClick={configureHandler}
                        label="Add"
                        className="btn-primary"
                    />
                )}
            </div>

            <hr />
            <h6>Configured Items: Language & Severity Level</h6>
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            {!isEdit && (
                <div className="m-top-30 card-body p-0 align-middle text-center table">
                    <DataTable
                        value={caTemplateNotice}
                        className="ca-configured-table"
                        rows={5}
                        paginator={caTemplateNotice?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                        <Column
                            header="Severity Level"
                            field="severity_level_name"
                            headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            sortable
                            sortField="severity_level_name"
                        />
                        <Column
                            header="Language"
                            field="emp_language_name"
                            headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            sortable
                            sortField="emp_language_name"
                        />
                        <Column
                            header="Description"
                            field="template_notice_text"
                            headerStyle={{ fontSize: 14, width: '500px' }}
                            bodyStyle={{ width: '500px' }}
                            body={(data) => renderDescription(data?.template_notice_text)}
                            sortable
                            sortField="template_notice_text"
                        />
                        <Column
                            header="Last Update"
                            field="last_update"
                            headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            body={(date) => (date.last_update ? DateTemplate(date?.last_update) : '--')}
                            sortable
                            sortField="last_update"
                        />
                        <Column body={actionTemplate} />
                    </DataTable>
                </div>
            )}

            <ControlDialogBox
                dialogVisibile={askcreateTempDialogVisible}
                IconPath={AskCreateTemplateIcon}
                footerTemplate={createFooterTemplate}
                subHeading={successHeader}
                subHeadingColor={'#7D71E2'}
                msgText={warningMessage}
                onDialogBoxHide={onAskCreateTempDialogBoxHide}
            />
            <ControlDialogBox
                dialogVisibile={createdSuccessTempdialogVisible}
                footerTemplate={CreatedSuccessfooterTemplate}
                IconPath={CreatedTemplateIcon}
                subHeading={successHeader}
                subHeadingColor={'#64D96E'}
                msgText={successMessage}
                onDialogBoxHide={onCreatedSuccessTempDialogBoxHide}
            />
        </>
    );
};
